module.exports = __webpack_public_path__ + "media/bootstrap-icons/bag-dash-f8bfee75.svg";